import React, { useEffect, useState } from "react";
import { Send, MessageSquare, UserPlus, CalendarClock, ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { getWeeklySeries } from "../../api";

const METRICS = [
  { k: "sent", l: "Emails envoyés", icon: Send, color: "#1e50ff" },
  { k: "replies", l: "Réponses reçues", icon: MessageSquare, color: "#f59e0b" },
  { k: "imported", l: "Prospects importés", icon: UserPlus, color: "#16a34a" },
  { k: "appointments", l: "RDV pris", icon: CalendarClock, color: "#a855f7" },
];
const weekLabel = (iso) => `S. du ${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

const Delta = ({ now, prev }) => {
  const diff = now - prev;
  const Icon = diff > 0 ? ArrowUpRight : diff < 0 ? ArrowDownRight : Minus;
  const cls = diff > 0 ? "text-emerald-600" : diff < 0 ? "text-red-600" : "text-neutral-400";
  return <span className={`flex items-center gap-0.5 text-xs font-semibold ${cls}`}><Icon size={13} /> {diff > 0 ? "+" : ""}{diff} vs sem. préc.</span>;
};

const WeeklyRecap = () => {
  const [weeks, setWeeks] = useState(null);
  useEffect(() => {
    getWeeklySeries(8).then((r) => setWeeks(r.data.weeks)).catch(() => setWeeks([]));
  }, []);
  if (!weeks?.length) return null;
  const cur = weeks[weeks.length - 1];
  const prev = weeks[weeks.length - 2] || {};
  const data = weeks.map((w) => ({ ...w, name: weekLabel(w.week) }));
  return (
    <section className="mt-8" data-testid="weekly-recap">
      <h3 className="font-heading font-bold text-lg text-neutral-900 mb-1">Bilan prospection — semaine en cours</h3>
      <p className="text-xs text-neutral-500 mb-4">Depuis le lundi {cur.week.slice(8, 10)}/{cur.week.slice(5, 7)} · comparé à la semaine précédente · bilan complet envoyé chaque vendredi 17h</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        {METRICS.map(({ k, l, icon: Icon, color }) => (
          <div key={k} className="bg-white border border-neutral-200 rounded-xl p-4" data-testid={`weekly-stat-${k}`}>
            <div className="flex items-center justify-between"><p className="text-sm text-neutral-500">{l}</p><Icon size={17} style={{ color }} /></div>
            <p className="font-heading font-extrabold text-3xl text-neutral-900 mt-1">{cur[k]}</p>
            <Delta now={cur[k]} prev={prev[k] || 0} />
          </div>
        ))}
      </div>
      <div className="bg-white border border-neutral-200 rounded-xl p-4 h-64" data-testid="weekly-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 0 }}>
            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            {METRICS.map((m) => <Bar key={m.k} dataKey={m.k} name={m.l} fill={m.color} radius={[3, 3, 0, 0]} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
};

export default WeeklyRecap;
